<template>
  <div :class="b({ available: availableSeats > 0 })">
    {{ label }}
  </div>
</template>

<script>
  /**
   * Renders the availability status for a course
   */
  export default {
    name: 'e-course-availability',

    // components: {},
    // mixins: [],

    props: {
      /**
       * Expects the number of available seats.
       */
      availableSeats: {
        type: Number,
        default: 0,
      },
    },
    // data() {
    //   return {};
    // },

    computed: {
      label() {
        const { availableSeats } = this;

        return availableSeats > 0
          ? this.$t('e-course-availability.availableSeats', availableSeats)
          : this.$t('e-course-availability.waitingList');
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .e-course-availability {
    display: flex;
    align-items: center;
    color: variables.$color-secondary--5;

    &::before {
      display: inline;
      content: '+';
      margin-right: functions.rem(variables.$spacing--5);
      font-size: 1.7em;
      line-height: 0; // Improves vertical centering.
    }

    &--available {
      color: variables.$color-secondary--4;

      @include mixins.media(lg) {
        @include mixins.font-size(variables.$font-size--16, variables.$font-size--lg-scale-basis);
      }

      &::before {
        content: '';
        width: functions.rem(12px);
        height: functions.rem(12px);
        border-radius: 50%;
        background-color: currentColor;
      }
    }
  }
</style>
